import { useState } from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import { BrokeNotificationQueryKeys } from '@/modules/client-setting/keys'
import {
	BrokeNotificationData,
	UpdateBrokeNotificationRequest,
} from '@/modules/client-setting/type'
import useMutationUpdateBrokeNotification from '@/modules/client-setting/api/hooks/useMutationUpdateBrokeNotification'
import { PencilIcon } from 'lucide-react'
import BrokeNotificationForm, {
	BrokeNotificationFormValues,
} from '../../../BrokeNotificationForm'

interface UpdateBrokeNotificationProps {
	data: BrokeNotificationData
}

export default function UpdateBrokeNotification({
	data,
}: UpdateBrokeNotificationProps) {
	const [open, setOpen] = useState(false)
	const { mutate: updateBrokeNotification } =
		useMutationUpdateBrokeNotification()
	const queryClient = useQueryClient()

	const defaultValues: BrokeNotificationFormValues = {
		title: data.title,
		content: data.content,
		imageUrl: data.imageUrl || '',
		linkText: data.linkText || '',
		type: data.type,
		depositPromotionId:
			((data as Record<string, unknown>).depositPromotionId as string) || '',
		shopItemId: ((data as Record<string, unknown>).shopItemId as string) || '',
		couponCode: ((data as Record<string, unknown>).couponCode as string) || '',
		isActive: data.isActive,
	}

	const onSubmit = (formData: BrokeNotificationFormValues) => {
		updateBrokeNotification(
			{
				id: data.id,
				payload: formData as unknown as UpdateBrokeNotificationRequest,
			},
			{
				onSuccess: () => {
					toast.success('แก้ไขประกาศสำเร็จ')
					setOpen(false)
					queryClient.invalidateQueries({
						queryKey: [BrokeNotificationQueryKeys.GetBrokeNotifications],
					})
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<PencilIcon className="size-4" />
				</Button>
			</DialogTrigger>
			<DialogContent className="sm:max-w-[800px]">
				<DialogHeader>
					<DialogTitle>แก้ไขประกาศเมื่อผู้เล่นเงินหมด</DialogTitle>
				</DialogHeader>
				<BrokeNotificationForm
					defaultValues={defaultValues}
					onSubmit={onSubmit}
					submitButtonText="แก้ไขประกาศ"
				/>
			</DialogContent>
		</Dialog>
	)
}
